import React from "react"
import { Box, Typography, Grid, Card, CardContent, Alert, Chip } from "@mui/material"
import { useTypedSelector } from "src/shared/store/store"
import { Conditional } from "src/shared/components"
import type { StepComponentProps } from "../types"
import { AUDIT_TYPES, AUTOMATIC_TYPES } from "../constants"

const AuditReview: React.FC<StepComponentProps> = ({ formData }) => {
  const currentLocation = useTypedSelector((state) => state.authentication.currentWhLoc)

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Review Audit Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Please review your audit settings before creating
      </Typography>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Location
              </Typography>
              <Typography variant="body1" fontWeight="medium">
                {currentLocation?.name || "Current Location"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Audit Type
              </Typography>
              <Chip
                label={AUDIT_TYPES.find((t) => t.value === formData.type)?.label}
                color="primary"
                variant="outlined"
              />
            </Grid>
            <Conditional condition={formData.type === "automatic"}>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">
                  Selection Criteria
                </Typography>
                <Typography variant="body1" fontWeight="medium">
                  {AUTOMATIC_TYPES.find((t) => t.value === formData.automaticType)?.label}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">
                  Percentage
                </Typography>
                <Typography variant="body1" fontWeight="medium">
                  {formData.percentage}%
                </Typography>
              </Grid>
            </Conditional>
            <Conditional condition={formData.type === "specific"}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary">
                  Selected Products
                </Typography>
                <Typography variant="body1" fontWeight="medium">
                  {formData.specificProducts?.length || 0} products selected
                </Typography>
              </Grid>
            </Conditional>
          </Grid>
        </CardContent>
      </Card>

      <Alert severity="success">
        <Typography variant="body2">
          <strong>Ready to create audit!</strong> All selected products with in-inventory status will change to in-audit
          status when the audit is created.
        </Typography>
      </Alert>
    </Box>
  )
}

export default AuditReview
